// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Queries */
#keyFocusSectionOne {
  background-color: #f7ebd7;
  height: auto !important;
  width: 100%;
  padding-top: 70px;
  scroll-snap-align: none !important;
  display: flex;
  flex-direction: row;
  position: relative;
  padding-bottom: 100px;
}

.keyFocusSectionOne-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6%;
  padding-left: 175px;
  width: 57%;
}

#keyFocusSectionOne-left-head {
  width: 100%;
  margin-top: 12%;
  font-size: 40px;
  font-weight: 500;
  line-height: 1.3em;
  margin-bottom: 30px;
}

#keyFocusSectionOne-left-middle {
  display: flex;
  flex-direction: row;
  width: 80%;
}

#keyFocusSectionOne-left-middle-left {
  margin-left: -65px;
  font-size: 18px;
  line-height: 1.86;
  border-right: unset !important;
}

#keyFocusSectionOne-discovermore {
  color: #ec6927;
  margin-top: 2%;
  cursor: pointer;
}

#keyFocusSectionOne-left-middle-right {
  text-align: left;
  margin-left: 5%;
}

#keyFocusSectionOne-left-middle-bottom {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 5%;
}

#keyFocusSectionOne-schedule-a-demo {
  width: 130px;
  height: 33px;
  background: #ec6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  cursor: pointer;
}

#keyFocusSectionOne-explore-how {
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  width: 25%;
  line-height: 16px;
}

.keyFocusSectionOne-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 50px;
}

#keyFocusSectionOne-page1-banner {
  width: 100%;
}

#keyFocusSectionOne-page1-video {
  position: absolute;
  margin-top: 50px;
}

.subtitle-video {
  font-weight: bold;
  margin-top: -50px;
}

.keyFocus-image-title {
  margin-left: -60px;
}

#keyFocusSectionOne-image-bg {
  margin-top: 75px;
}

.keyFocus-image {
  width: 90%;
}

.keyFocusSectionOne-Menu .ui.secondary.pointing.menu {
  height: 60px;
  justify-content: center;
  align-items: center;
}
.keyFocusSectionOne-Menu .ui.secondary.pointing.menu .item {
  height: 60px;
  min-width: 250px;
  width: 20%;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.keyFocusSectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
  font-size: 18px !important;
  font-weight: 500;
  font-family: "Roboto", Roboto !important;
  color: #1c2640;
  line-height: 1.86;
  height: 60px;
  padding: inherit;
}
.keyFocusSectionOne-Menu .ui.secondary.pointing.menu .item:hover {
  cursor: pointer;
}
.keyFocusSectionOne-Menu .ui.secondary.pointing.menu .item:hover .ui.header {
  color: #ec7c45;
  border-bottom: 4px solid #ec7c45;
  transition: 0.4s;
}

.keyFocusSectionOne-content-carousel {
  background-color: #f9fbff;
  padding: 20px 10px;
}
.keyFocusSectionOne-content-carousel .top-carousel {
  margin-bottom: -10px;
}
.keyFocusSectionOne-content-carousel .top-carousel .img-carousel {
  width: 280px;
  padding: 10px;
  display: inline-block;
  animation: marqueeRight 5s linear infinite;
}
.keyFocusSectionOne-content-carousel .bottom-carousel {
  margin-bottom: -10px;
}
.keyFocusSectionOne-content-carousel .bottom-carousel .img-carousel {
  width: 300px;
  padding: 10px;
  display: inline-block;
  animation: marqueeLeft 5s linear infinite;
}
.keyFocusSectionOne-content-carousel .marquee {
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}
@keyframes marqueeRight {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}
@keyframes marqueeLeft {
  0% {
    transform: translate(-100%, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}

.keyFocusSectionOne-content-wrapper {
  background: #e2e6fb;
}
.keyFocusSectionOne-content-wrapper .section-custom {
  height: auto;
  padding: 100px 150px 100px 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left {
  width: 60%;
}
.keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content {
  padding-left: 0px;
}
.keyFocusSectionOne-content-wrapper .section-custom .txt-content {
  margin-top: 50px;
  font-size: 18px;
  margin-left: 0px;
  line-height: 1.8em;
  width: 80%;
}
.keyFocusSectionOne-content-wrapper .section-custom .txt-content-two {
  margin-top: 50px;
  font-size: 18px;
  margin-left: 150px;
  line-height: 1.8em;
  width: 80%;
}
.keyFocusSectionOne-content-wrapper .section-custom .img-content {
  width: 500px;
}

@media only screen and (min-width: 280px) and (max-width: 482px), only screen and (min-width: 482px) and (max-width: 599px), only screen and (min-width: 482px) and (max-width: 666px) {
  #keyFocusSectionOne {
    padding: 100px 30px 30px;
    flex-direction: column;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left {
    padding-left: 0;
    width: 100%;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-head {
    margin-top: 0;
    font-size: 28px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle {
    width: 100%;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle #keyFocusSectionOne-left-middle-left {
    margin-right: 10px;
    margin-left: 0;
    font-size: 14px;
    text-align: justify;
    line-height: 1.8;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right {
    width: 100%;
    margin-top: 30px;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right .keyFocus-image {
    width: 100%;
    margin-right: 0;
    padding-right: 10px;
  }
  .keyFocusSectionOne-content-wrapper {
    padding: 50px 30px 30px;
  }
  .keyFocusSectionOne-content-wrapper .section-custom {
    padding: 0;
    flex-direction: column;
    background: #fff;
    margin-bottom: 40px;
    box-shadow: 0px 5px 7px 0 rgba(36, 50, 66, 0.1411764706);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left {
    text-align: center;
    width: 100%;
    overflow: hidden;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content {
    padding: 20px;
    margin-top: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.8;
    width: 100%;
    text-align: left;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left .img-content {
    width: 100%;
    transform: scale(1.13);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right {
    width: 100%;
    text-align: center;
    overflow: hidden;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .img-content {
    width: 100%;
    transform: scale(1.13);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content-two {
    padding: 20px;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.8;
    width: 100%;
    text-align: left;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-1 {
    flex-direction: column-reverse;
  }
}
@media only screen and (min-width: 600px) and (max-width: 900px) {
  .keyFocusSectionOne-content-wrapper .section-custom-1 {
    flex-direction: row-reverse;
    border-radius: 10px;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-1 .content-wrapper-left {
    flex: 2 1;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-1 .content-wrapper-left .txt-content {
    padding: 20px 50px !important;
    text-align: left !important;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-1 .content-wrapper-right {
    flex: 1 1;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-2 {
    flex-direction: row;
    border-radius: 10px;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-2 .content-wrapper-left {
    flex: 1 1;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-2 .content-wrapper-right {
    flex: 2 1;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-2 .content-wrapper-right .txt-content-two {
    padding: 20px 50px !important;
    text-align: left !important;
  }
}
@media only screen and (min-width: 667px) and (max-width: 900px) {
  #keyFocusSectionOne {
    padding: 100px 30px 30px;
    display: block;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left {
    width: 100%;
    padding: 0;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-head {
    font-size: 28px;
    font-weight: bold;
    line-height: 1.33;
    margin-bottom: 20px;
    margin-top: 0;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle {
    width: 100%;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle #keyFocusSectionOne-left-middle-left {
    margin-left: 0;
    font-size: 16px;
    line-height: 1.8;
    padding-right: 10px;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right {
    width: 100%;
    margin-top: 30px;
    padding-right: 10px;
    align-items: flex-end;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right .keyFocus-image {
    height: 350px;
    width: auto;
    margin-right: 0;
  }
  .keyFocusSectionOne-content-wrapper {
    padding: 50px 30px 30px;
  }
  .keyFocusSectionOne-content-wrapper .section-custom {
    padding: 0;
    flex-direction: column;
    background: #fff;
    margin-bottom: 50px;
    box-shadow: 0px 5px 7px 0 rgba(36, 50, 66, 0.1411764706);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left {
    text-align: center;
    width: 100%;
    overflow: hidden;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content {
    padding: 30px 50px;
    margin-top: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.8;
    width: 100%;
    text-align: center;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left .img-content {
    width: 100%;
    transform: scale(1.13);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right {
    width: 100%;
    text-align: center;
    overflow: hidden;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .img-content {
    width: 100%;
    transform: scale(1.13);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content-two {
    padding: 30px 50px;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.8;
    width: 100%;
    text-align: center;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-1 {
    flex-direction: row-reverse;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-2 {
    flex-direction: row;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  #keyFocusSectionOne {
    padding: 60px 30px;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left {
    padding-left: 0;
    width: 45%;
    margin-top: 50px;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-head {
    width: 100%;
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 30px;
    margin-top: 0;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle {
    width: 100%;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle #keyFocusSectionOne-left-middle-left {
    margin-left: 0;
    font-size: 16px;
    line-height: 1.8;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right {
    width: 55%;
    align-items: flex-start;
    justify-content: flex-end;
    flex-direction: unset;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right .keyFocus-image {
    margin-top: 10px;
    margin-right: -40px;
    width: 100%;
    transform: scale(1.1);
  }
  .keyFocusSectionOne-content-wrapper {
    padding: 100px 70px 50px;
  }
  .keyFocusSectionOne-content-wrapper .section-custom {
    padding: 0;
    margin-bottom: 50px;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left .txt-content {
    padding-left: 10px;
    margin-top: 0;
    font-size: 16px;
    line-height: 1.8;
    width: 100%;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-left .img-content {
    width: 90%;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right {
    width: 60%;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .img-content {
    width: 90%;
  }
  .keyFocusSectionOne-content-wrapper .section-custom .content-wrapper-right .txt-content-two {
    padding-right: 10px;
    padding-left: 20px;
    margin-left: 0;
    margin-top: 0;
    font-size: 16px;
    line-height: 1.8;
    width: 100%;
  }
  .keyFocusSectionOne-content-wrapper .section-custom-1 .content-wrapper-right {
    text-align: right;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  #keyFocusSectionOne {
    padding: 70px 60px;
  }
  .keyFocusSectionOne-left {
    width: 50% !important;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1482px) {
  #keyFocusSectionOne {
    padding: 100px 120px;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left {
    padding-left: 0;
    flex: 1 1;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle {
    width: 100%;
  }
  #keyFocusSectionOne .keyFocusSectionOne-left #keyFocusSectionOne-left-middle #keyFocusSectionOne-left-middle-left {
    margin-left: 0;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right {
    flex: 1 1;
    align-items: flex-end;
    justify-content: flex-start;
  }
  #keyFocusSectionOne .keyFocusSectionOne-right .keyFocus-image {
    width: 100%;
    margin-top: 49px;
    margin-right: -65px;
    transform: scale(1.3);
  }
  .keyFocusSectionOne-content-wrapper .section-custom .txt-content-two {
    margin-left: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./src/media-queries.scss","webpack://./src/components/KeyFocus/SectionOne/sectionOne.scss"],"names":[],"mappings":"AAEA,kBAAA;ACSA;EACC,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AATD;;AAYA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AATD;;AAYA;EACC,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AATD;;AAYA;EACC,aAAA;EACA,mBAAA;EACA,UAAA;AATD;;AAYA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AATD;;AAYA;EACC,cAAA;EACA,cAAA;EACA,eAAA;AATD;;AAWA;EACC,gBAAA;EACA,eAAA;AARD;;AAWA;EACC,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;AARD;;AAWA;EACC,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AARD;;AAWA;EACC,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;AARD;;AAWA;EACC,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AARD;;AAWA;EACC,WAAA;AARD;;AAWA;EACC,kBAAA;EACA,gBAAA;AARD;;AAWA;EACC,iBAAA;EACA,iBAAA;AARD;;AAUA;EACI,kBAAA;AAPJ;;AASA;EACC,gBAAA;AAND;;AASA;EACC,UAAA;AAND;;AAWC;EACC,YAAA;EACA,uBAAA;EACA,mBAAA;AARF;AAWC;EACC,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AATF;AAUE;EACC,0BAAA;EACA,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AARH;AAYC;EACC,eAAA;AAVF;AAWE;EACC,cAAA;EACA,gCAAA;EACA,gBAAA;AATH;;AAcA;EACC,yBAAA;EACA,kBAAA;AAXD;AAaC;EACC,oBAAA;AAXF;AAYE;EACC,YAAA;EACA,aAAA;EACA,qBAAA;EACG,0CAAA;AAVN;AAcC;EACC,oBAAA;AAZF;AAaE;EACC,YAAA;EACA,aAAA;EACA,qBAAA;EACG,yCAAA;AAXN;AAeC;EACI,mBAAA;EACA,gBAAA;EACA,sBAAA;AAbL;AAgBC;EACI;IAAO,0BAAA;EAbV;EAcG;IAAO,8BAAA;EAXV;AACF;AAaC;EACC;IAAK,8BAAA;EAVL;EAWG;IAAS,0BAAA;EARZ;AACF;;AAYA;EACC,mBAAA;AATD;AAUC;EACC,YAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARF;AAUE;EACC,UAAA;AARH;AAYG;EACC,iBAAA;AAVJ;AAcE;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAZH;AAeE;EACC,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAbH;AAgBE;EACC,YAAA;AAdH;;ADhMI;ECsNF;IACC,wBAAA;IACA,sBAAA;EAlBD;EAmBC;IACC,eAAA;IACA,WAAA;EAjBF;EAkBE;IACC,aAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;EAhBH;EAkBE;IACC,WAAA;EAhBH;EAiBG;IACC,kBAAA;IACA,cAAA;IACA,eAAA;IACG,mBAAA;IACA,gBAAA;EAfP;EAmBC;IACC,WAAA;IACA,gBAAA;EAjBF;EAkBE;IACC,WAAA;IACA,eAAA;IACA,mBAAA;EAhBH;EAqBA;IACC,uBAAA;EAnBD;EAoBC;IACC,UAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;IACA,wDAAA;EAlBF;EAmBE;IACC,kBAAA;IACA,WAAA;IACA,gBAAA;EAjBH;EAkBG;IACC,aAAA;IACA,aAAA;IACG,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAhBP;EAkBG;IACC,WAAA;IACA,sBAAA;EAhBJ;EAmBE;IACC,WAAA;IACA,kBAAA;IACA,gBAAA;EAjBH;EAkBG;IACC,WAAA;IACA,sBAAA;EAhBJ;EAkBG;IACC,aAAA;IACA,SAAA;IACG,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;EAhBP;EAoBC;IACC,8BAAA;EAlBF;AACF;ADrRI;EC6SD;IACC,2BAAA;IACA,mBAAA;EArBF;EAsBE;IACC,SAAA;EApBH;EAqBG;IACC,6BAAA;IACA,2BAAA;EAnBJ;EAsBE;IACC,SAAA;EApBH;EAuBC;IACC,mBAAA;IACA,mBAAA;EArBF;EAsBE;IACC,SAAA;EApBH;EAsBE;IACC,SAAA;EApBH;EAqBG;IACC,6BAAA;IACA,2BAAA;EAnBJ;AACF;ADnTI;EC6UF;IACC,wBAAA;IACA,cAAA;EAvBD;EAwBC;IACC,WAAA;IACA,UAAA;EAtBF;EAuBE;IACC,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,mBAAA;IACA,aAAA;EArBH;EAuBE;IACC,WAAA;EArBH;EAsBG;IACC,cAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EApBJ;EAwBC;IACC,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,qBAAA;EAtBF;EAuBE;IACC,aAAA;IACA,WAAA;IACA,eAAA;EArBH;EA0BA;IACC,uBAAA;EAxBD;EAyBC;IACC,UAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;IACA,wDAAA;EAvBF;EAwBE;IACC,kBAAA;IACA,WAAA;IACA,gBAAA;EAtBH;EAuBG;IACC,kBAAA;IACA,aAAA;IACG,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;EArBP;EAuBG;IACC,WAAA;IACA,sBAAA;EArBJ;EAwBE;IACC,WAAA;IACA,kBAAA;IACA,gBAAA;EAtBH;EAuBG;IACC,WAAA;IACA,sBAAA;EArBJ;EAuBG;IACC,kBAAA;IACA,SAAA;IACG,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;EArBP;EAyBC;IACC,2BAAA;EAvBF;EAyBC;IACC,mBAAA;EAvBF;AACF;AD5YI;ECwaF;IACC,kBAAA;EAzBD;EA0BC;IACC,eAAA;IACA,UAAA;IACA,gBAAA;EAxBF;EAyBE;IACC,WAAA;IACG,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,aAAA;EAvBN;EAyBE;IACC,WAAA;EAvBH;EAwBG;IACC,cAAA;IACA,eAAA;IACG,gBAAA;EAtBP;EA0BC;IACC,UAAA;IACA,uBAAA;IACA,yBAAA;IACA,qBAAA;EAxBF;EAyBE;IACC,gBAAA;IACA,mBAAA;IACA,WAAA;IACA,qBAAA;EAvBH;EA4BA;IACC,wBAAA;EA1BD;EA2BC;IACC,UAAA;IACA,mBAAA;EAzBF;EA2BG;IACC,kBAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EAzBJ;EA2BG;IACC,UAAA;EAzBJ;EA4BE;IACC,UAAA;EA1BH;EA2BG;IACC,UAAA;EAzBJ;EA2BG;IACC,mBAAA;IACA,kBAAA;IACA,cAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;EAzBJ;EA8BE;IACC,iBAAA;EA5BH;AACF;ADpdI;ECsfF;IACC,kBAAA;EA/BD;EAiCA;IACC,qBAAA;EA/BD;AACF;AD5dI;EC+fF;IACC,oBAAA;EAhCD;EAiCC;IACC,eAAA;IACA,SAAA;EA/BF;EAgCE;IACC,WAAA;EA9BH;EA+BG;IACC,cAAA;EA7BJ;EAiCC;IACC,SAAA;IACA,qBAAA;IACG,2BAAA;EA/BL;EAgCK;IACC,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,qBAAA;EA9BN;EAkCA;IACC,kBAAA;EAhCD;AACF","sourcesContent":["$size__site_content_width : 1024px;\n\n/* Media Queries */ \n\n$media_queries : (\n    'mobile360'         : unquote(\"only screen and (min-width: 280px) and (max-width: 400px)\"),\n    'xs'                : unquote(\"only screen and (min-width: 280px) and (max-width: 482px)\"),\n    'miniMobile'        : unquote(\"only screen and (min-width: 280px) and (max-width: 450px)\"),\n    'mediumMobile'      : unquote(\"only screen and (min-width: 450px) and (max-width: 482px)\"),\n    'eReaders'          : unquote(\"only screen and (min-width: 482px) and (max-width: 599px)\"),\n    'mobile'            : unquote(\"only screen and (min-width: 482px) and (max-width: 666px)\"),\n    'customMobile'      : unquote(\"only screen and (min-width: 600px) and (max-width: 900px)\"),\n    'miniTab'           : unquote(\"only screen and (min-width: 667px) and (max-width: 900px)\"),\n    'tablet'            : unquote(\"only screen and (min-width: 667px) and (max-width: 1023px)\"),\n    'customTablet'      : unquote(\"only screen and (min-width: 900px) and (max-width: 1023px)\"),\n    'wideTablet'        : unquote(\"only screen and (min-width: 1024px) and (max-width: 1280px)\"),\n    'miniDesktop'       : unquote(\"only screen and (min-width: 1281px) and (max-width: 1482px)\"),\n    'desktop'           : unquote(\"only screen and (min-width: 1025px)\"),\n    'wideScreens'       : unquote(\"only screen and (min-width: 1339px)\"),\n    'hdScreen'          : unquote(\"only screen and (min-width: 1800px)\"),\n    'retina2'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)\"),\n    'retina3'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 288dpi)\"),\n    'landscape'         : unquote(\"screen and (orientation:landscape)\"),    \n    'portrait'          : unquote(\"screen and (orientation:portrait)\")\n);\n\n@mixin devices($breakpoints) {\n    $conditions : ();\n    @each $breakpoint in $breakpoints {\n        // If the key exists in the map\n        $conditions: append(\n            $conditions,\n            #{inspect(map-get($media_queries, $breakpoint))},\n            comma\n        );\n    }\n\n    @media #{$conditions} {\n        @content;\n    }\n\n}\n","@import '../../../media-queries.scss';\n// section, .getStart-bottom {\n//     scroll-snap-align: none !important;\n// }\n\n// .footer{\n//     .section-bottom{\n//         scroll-snap-align: none !important;\n//     }\n// }\n\n#keyFocusSectionOne {\n\tbackground-color: #f7ebd7;\n\theight: auto !important;\n\twidth: 100%;\n\tpadding-top: 70px;\n\tscroll-snap-align: none !important;\n\tdisplay: flex;\n\tflex-direction: row;\n\tposition: relative;\n\tpadding-bottom: 100px;\n}\n\n.keyFocusSectionOne-left {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 6%;\n\tpadding-left: 175px;\n\twidth: 57%;\n}\n\n#keyFocusSectionOne-left-head {\n\twidth: 100%;\n\tmargin-top: 12%;\n\tfont-size: 40px;\n\tfont-weight: 500;\n\tline-height: 1.3em;\n\tmargin-bottom: 30px;\n}\n\n#keyFocusSectionOne-left-middle {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 80%;\n}\n\n#keyFocusSectionOne-left-middle-left {\n\tmargin-left: -65px;\n\tfont-size: 18px;\n\tline-height: 1.86;\n\tborder-right: unset !important;\n}\n\n#keyFocusSectionOne-discovermore {\n\tcolor: #ec6927;\n\tmargin-top: 2%;\n\tcursor: pointer;\n}\n#keyFocusSectionOne-left-middle-right {\n\ttext-align: left;\n\tmargin-left: 5%;\n}\n\n#keyFocusSectionOne-left-middle-bottom {\n\twidth: 80%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: flex-start;\n\tgap: 5%;\n}\n\n#keyFocusSectionOne-schedule-a-demo {\n\twidth: 130px;\n\theight: 33px;\n\tbackground: #ec6927;\n\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\tborder-radius: 3px;\n\tborder: none;\n\tcolor: white;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 13.5px;\n\tcursor: pointer;\n}\n\n#keyFocusSectionOne-explore-how {\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 13.5px;\n\twidth: 25%;\n\tline-height: 16px;\n}\n\n.keyFocusSectionOne-right {\n\twidth: 50%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\tmargin-top: 50px;\n}\n\n#keyFocusSectionOne-page1-banner {\n\twidth: 100%;\n}\n\n#keyFocusSectionOne-page1-video {\n\tposition: absolute;\n\tmargin-top: 50px;\n}\n\n.subtitle-video {\n\tfont-weight: bold;\n\tmargin-top: -50px;\n}\n.keyFocus-image-title {\n    margin-left: -60px;\n}\n#keyFocusSectionOne-image-bg {\n\tmargin-top: 75px;\n}\n\n.keyFocus-image {\n\twidth: 90%;\n\t// margin-right: -70px;\n}\n\n.keyFocusSectionOne-Menu {\n\t.ui.secondary.pointing.menu {\n\t\theight: 60px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.ui.secondary.pointing.menu .item {\n\t\theight: 60px;\n\t\tmin-width: 250px;\n\t\twidth: 20%;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t\t.ui.header {\n\t\t\tfont-size: 18px !important;\n\t\t\tfont-weight: 500;\n\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\tcolor: #1c2640;\n\t\t\tline-height: 1.86;\n\t\t\theight: 60px;\n\t\t\tpadding: inherit;\n\t\t}\n\t}\n\n\t.ui.secondary.pointing.menu .item:hover {\n\t\tcursor: pointer;\n\t\t.ui.header {\n\t\t\tcolor: #ec7c45;\n\t\t\tborder-bottom: 4px solid #ec7c45;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t}\n}\n\n.keyFocusSectionOne-content-carousel {\n\tbackground-color: #f9fbff;\n\tpadding: 20px 10px;\n\n\t.top-carousel {\n\t\tmargin-bottom: -10px;\n\t\t.img-carousel {\n\t\t\twidth: 280px;\n\t\t\tpadding: 10px;\n\t\t\tdisplay: inline-block;\n\t    \tanimation: marqueeRight 5s linear infinite;\n\t\t}\n\t}\n\n\t.bottom-carousel {\n\t\tmargin-bottom: -10px;\n\t\t.img-carousel {\n\t\t\twidth: 300px;\n\t\t\tpadding: 10px;\n\t\t\tdisplay: inline-block;\n\t    \tanimation: marqueeLeft 5s linear infinite;\n\t\t}\n\t}\n\n\t.marquee {\n\t    white-space: nowrap;\n\t    overflow: hidden;\n\t    box-sizing: border-box;\n\t}\n\n\t@keyframes marqueeRight {\n\t    0%   { transform: translate(0, 0); }\n\t    100% { transform: translate(-100%, 0); }\n\t}\n\n\t@keyframes marqueeLeft {\n\t\t0% { transform: translate(-100%, 0); }\n\t    100%   { transform: translate(0, 0); }\n\t    \n\t}\n}\n\n.keyFocusSectionOne-content-wrapper {\n\tbackground: #e2e6fb;\n\t.section-custom {\n\t\theight: auto;\n\t\tpadding: 100px 150px 100px 150px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.content-wrapper-left {\n\t\t\twidth: 60%;\n\t\t}\n\n\t\t.content-wrapper-right {\n\t\t\t.txt-content {\n\t\t\t\tpadding-left: 0px;\n\t\t\t}\n\t\t}\n\n\t\t.txt-content {\n\t\t\tmargin-top: 50px;\n\t\t\tfont-size: 18px;\n\t\t\tmargin-left: 0px;\n\t\t\tline-height: 1.8em;\n\t\t\twidth: 80%;\n\t\t}\n\n\t\t.txt-content-two {\n\t\t\tmargin-top: 50px;\n\t\t\tfont-size: 18px;\n\t\t\tmargin-left: 150px;\n\t\t\tline-height: 1.8em;\n\t\t\twidth: 80%;\n\t\t}\n\n\t\t.img-content {\n\t\t\twidth: 500px;\n\t\t}\n\t}\n}\n\n\n// Responsive\n\t@include devices(xs eReaders mobile) {\n\t\t#keyFocusSectionOne {\n\t\t\tpadding: 100px 30px 30px;\n\t\t\tflex-direction: column;\n\t\t\t.keyFocusSectionOne-left {\n\t\t\t\tpadding-left: 0;\n\t\t\t\twidth: 100%;\n\t\t\t\t#keyFocusSectionOne-left-head {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t\t#keyFocusSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#keyFocusSectionOne-left-middle-left {\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t    text-align: justify;\n\t\t\t\t\t    line-height: 1.8;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.keyFocusSectionOne-right {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-top: 30px;\n\t\t\t\t.keyFocus-image {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\tpadding-right: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.keyFocusSectionOne-content-wrapper {\n\t\t\tpadding: 50px 30px 30px;\n\t\t\t.section-custom {\n\t\t\t\tpadding: 0;\n\t\t\t\tflex-direction: column;\n\t\t\t\tbackground: #fff;\n\t\t\t\tmargin-bottom: 40px;\n\t\t\t\tbox-shadow: 0px 5px 7px 0 #24324224;\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t.txt-content {\n\t\t\t\t\t\tpadding: 20px;\n\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t    font-size: 14px;\n\t\t\t\t\t    font-weight: 400;\n\t\t\t\t\t    line-height: 1.8;\n\t\t\t\t\t    width: 100%;\n\t\t\t\t\t    text-align: left;\n\t\t\t\t\t}\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\ttransform: scale(1.13);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\ttransform: scale(1.13);\n\t\t\t\t\t}\n\t\t\t\t\t.txt-content-two {\n\t\t\t\t\t\tpadding: 20px;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t    font-size: 14px;\n\t\t\t\t\t    font-weight: 400;\n\t\t\t\t\t    line-height: 1.8;\n\t\t\t\t\t    width: 100%;\n\t\t\t\t\t    text-align: left;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom-1 {\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t}\n\t\t}\n\t}\n\n\t@include devices(customMobile) {\n\t\t.keyFocusSectionOne-content-wrapper {\n\t\t\t.section-custom-1 {\n\t\t\t\tflex-direction: row-reverse;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\tflex: 2;\n\t\t\t\t\t.txt-content {\n\t\t\t\t\t\tpadding: 20px 50px !important;\n\t\t\t\t\t\ttext-align: left !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom-2 {\n\t\t\t\tflex-direction: row;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\tflex: 2;\n\t\t\t\t\t.txt-content-two {\n\t\t\t\t\t\tpadding: 20px 50px !important;\n\t\t\t\t\t\ttext-align: left !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t@include devices(miniTab) {\n\t\t#keyFocusSectionOne {\n\t\t\tpadding: 100px 30px 30px;\n\t\t\tdisplay: block;\n\t\t\t.keyFocusSectionOne-left {\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 0;\n\t\t\t\t#keyFocusSectionOne-left-head {\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tline-height: 1.33;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t\t#keyFocusSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#keyFocusSectionOne-left-middle-left {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t\tpadding-right: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.keyFocusSectionOne-right {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin-top: 30px;\n\t\t\t\tpadding-right: 10px;\n\t\t\t\talign-items: flex-end;\n\t\t\t\t.keyFocus-image {\n\t\t\t\t\theight: 350px;\n\t\t\t\t\twidth: auto;\n\t\t\t\t\tmargin-right: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.keyFocusSectionOne-content-wrapper {\n\t\t\tpadding: 50px 30px 30px;\n\t\t\t.section-custom {\n\t\t\t\tpadding: 0;\n\t\t\t\tflex-direction: column;\n\t\t\t\tbackground: #fff;\n\t\t\t\tmargin-bottom: 50px;\n\t\t\t\tbox-shadow: 0px 5px 7px 0 #24324224;\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t.txt-content {\n\t\t\t\t\t\tpadding: 30px 50px;\n\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t    font-size: 16px;\n\t\t\t\t\t    font-weight: 400;\n\t\t\t\t\t    line-height: 1.8;\n\t\t\t\t\t    width: 100%;\n\t\t\t\t\t    text-align: center;\n\t\t\t\t\t}\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\ttransform: scale(1.13);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\ttransform: scale(1.13);\n\t\t\t\t\t}\n\t\t\t\t\t.txt-content-two {\n\t\t\t\t\t\tpadding: 30px 50px;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t    font-size: 16px;\n\t\t\t\t\t    font-weight: 400;\n\t\t\t\t\t    line-height: 1.8;\n\t\t\t\t\t    width: 100%;\n\t\t\t\t\t    text-align: center;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom-1 {\n\t\t\t\tflex-direction: row-reverse;\n\t\t\t}\n\t\t\t.section-custom-2 {\n\t\t\t\tflex-direction: row;\n\t\t\t}\n\t\t}\n\t}\n\n\t@include devices(customTablet wideTablet) {\n\t\t#keyFocusSectionOne{\n\t\t\tpadding: 60px 30px;\n\t\t\t.keyFocusSectionOne-left {\n\t\t\t\tpadding-left: 0;\n\t\t\t\twidth: 45%;\n\t\t\t\tmargin-top: 50px;\n\t\t\t\t#keyFocusSectionOne-left-head {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t    font-size: 28px;\n\t\t\t\t    font-weight: bold;\n\t\t\t\t    margin-bottom: 30px;\n\t\t\t\t    margin-top: 0;\n\t\t\t\t}\n\t\t\t\t#keyFocusSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#keyFocusSectionOne-left-middle-left {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tfont-size: 16px;\n\t    \t\t\t\tline-height: 1.8;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.keyFocusSectionOne-right {\n\t\t\t\twidth: 55%;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\tflex-direction: unset;\n\t\t\t\t.keyFocus-image {\n\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t\tmargin-right: -40px;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.keyFocusSectionOne-content-wrapper {\n\t\t\tpadding: 100px 70px 50px;\n\t\t\t.section-custom {\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin-bottom: 50px;\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\t.txt-content {\n\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 90%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\twidth: 60%;\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 90%;\n\t\t\t\t\t}\n\t\t\t\t\t.txt-content-two {\n\t\t\t\t\t\tpadding-right: 10px;\n\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom-1 {\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t@include devices(wideTablet) {\n\t\t#keyFocusSectionOne {\n\t\t\tpadding: 70px 60px;\n\t\t}\n\t\t.keyFocusSectionOne-left {\n\t\t\twidth: 50% !important;\n\t\t}\n\t}\n\n\t@include devices(miniDesktop) {\n\t\t#keyFocusSectionOne {\n\t\t\tpadding: 100px 120px;\n\t\t\t.keyFocusSectionOne-left {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tflex: 1;\n\t\t\t\t#keyFocusSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#keyFocusSectionOne-left-middle-left {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.keyFocusSectionOne-right {\n\t\t\t\tflex: 1;\n\t\t\t\talign-items: flex-end;\n    \t\t\tjustify-content: flex-start;\n    \t\t\t.keyFocus-image {\n    \t\t\t\twidth: 100%;\n    \t\t\t\tmargin-top: 49px;\n    \t\t\t\tmargin-right: -65px;\n    \t\t\t\ttransform: scale(1.3);\n    \t\t\t}\n\t\t\t}\n\t\t}\n\t\t.keyFocusSectionOne-content-wrapper .section-custom .txt-content-two {\n\t\t\tmargin-left: 130px;\n\t\t}\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
